/* eslint-disable padding-line-between-statements */
/* eslint-disable import/order */
import { BreakpointTrackerContext } from '@jutro/layout';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { QuestionSetComponent } from '@xengage/gw-portals-questionsets-ui';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
// eslint-disable-next-line import/no-unresolved
import config from 'app-config';
import _, { update } from 'lodash';
import React, { useCallback, useContext, useState } from 'react';
import { Loader, useModal } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import metadata from './AdditionalInformationPage.metadata.json5';
import messages from './AdditionalInformationPage.messages.js';
import styles from './AdditionalInformationPage.module.scss';
import TFPAAdditionalInsuredComponent from '../../components/TFPAAdditionalInsuredComponent/TFPAAdditionalInsuredComponent.jsx';
import AdditionalInterestComponent from '../../components/AdditionalInformation/AdditionalInterestComponent/AdditionalInterestComponent.jsx';
import ErrorPopupUtil from 'ent-components-platform-react/util/ErrorPopupUtil.js';
import { CustomQuoteService } from 'twia-capability-quoteandbind-residential';
import PrintDocumentUtils from 'ent-capability-quoteandbind-common-react/util/PrintDocumentUtils.js';
import PrintDocumentConfirmationPopup from 'ent-capability-quoteandbind-common-react/pages/PrintDocument/PrintDocumentConfirmationPopup';
import PrintDocumentErrorPopup from 'ent-capability-quoteandbind-common-react/pages/PrintDocument/PrintDocumentErrorPopup';


const LOB_PATH = {
    PersonalAuto: 'lobData.personalAuto.preQualQuestionSets.children[0].value',
    Homeowners: 'lobData.homeowners.preQualQuestionSets.children[0].value',
    HOPHomeowners: 'lobData.homeowners.preQualQuestionSets.children[0].value',
    BusinessOwners:
        'lobData.businessOwners.preQualQuestionSets.children[0].value',
    BusinessAuto:
        'lobData.businessOwners.preQualQuestionSets.children[0].value',
};

function TFPAAdditionalInformationPage(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const { wizardData: submissionVM, updateWizardData } = props;
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const { authHeader } = useAuthentication();
    const translator = useTranslator();
    const [isLoading, setIsLoading] = useState(false);
    const [isPrinting, setIsPrinting] = useState(false);
    const { showAlert, showConfirm, showModal } = useModal();
    const [invalidComponent, setInvalidComponents] = useState([]);
    const [showErrors, setShowErrors] = useState(false);
    const {
        registerInitialComponentValidation,
        isComponentValid,
        initialValidation,
        onValidate,
        onResolve,
        onAfterClose
    } = useValidation('TFPAAdditionalInformationPage');   
    const viewModelService = useContext(ViewModelServiceContext);
    const policyType = _.get(submissionVM, 'lobData.homeowners_tfpa.policyType_TWIA.value.code');
    const [errorDescription, setShowErrorDescription] = useState(undefined);
    
    const onNext = useCallback(async () => {

        const isportalPayorTypeValid = _.get(submissionVM, 'bindData_TFPA.portalPayorType_Ext.aspects.valid');
        const portalPayorType = _.get(submissionVM, "bindData_TFPA.portalPayorType_Ext.value");
        const iscontactPhoneValid = _.get(submissionVM, 'bindData_TFPA.contactPhone.aspects.valid');
        const contactPhone = _.get(submissionVM, 'bindData_TFPA.contactPhone.value');
        const payorType =_.get(submissionVM, "bindData_TFPA.payorType_Ext.value.code");

        // It is used to avoid dto validation error when we go to summary screen and come back to additional info. 
        // There is no impact even we pass a value. it is being undefined from backend call.
        if (isportalPayorTypeValid === false && portalPayorType === undefined) {
            _.set(submissionVM, 'bindData_TFPA.portalPayorType_Ext.value', "mortgageeescrow")
        }

        if (iscontactPhoneValid === false && contactPhone === undefined) {
            _.set(submissionVM, 'bindData_TFPA.contactPhone.value', "")
        }

        if (payorType !== undefined) {
            _.set(submissionVM.value, 'bindData_TFPA.payor_Ext.subtype', 'PolicyPriNamedInsured')
        }

        if (invalidComponent.length > 0 || errorDescription?.defaultMessage !== undefined) { //DE16296
            setShowErrors(true)
            return false;
        }
        // eslint-disable-next-line padding-line-between-statements
        setShowErrors(false);

        try {
            const newSubmissionVM = _.cloneDeep(submissionVM);

            submissionVM.value = await LoadSaveService.updateQuotedSubmission(
                newSubmissionVM.value,
                authHeader
            );
            updateWizardData(submissionVM);

            return submissionVM;
        } catch (error) {
            ErrorPopupUtil.showSaveErrorPopup(showAlert, false);
            
            return false;
            // return submissionVM;
        }
    }, [invalidComponent, errorDescription?.defaultMessage, submissionVM, 
        LoadSaveService, authHeader, updateWizardData, showAlert]);

    const findInvalidComponent = useCallback((isValid, componentID) => {
        setShowErrors(false);
        
        if (isValid === false) {
            setInvalidComponents((oldValue) => [...oldValue, componentID]);
        }

        if (isValid === true) {
            setInvalidComponents((oldValue) => oldValue.filter((val) => val !== componentID));
        }
    }, []);

    // const quotePrintDocument = useCallback(async () => {
    //     setIsPrinting(true);
    //     await PrintDocumentUtil.printDocument(submissionVM, showConfirm, showAlert, translator, authHeader, setIsPrinting);
        

    // }, [authHeader, showAlert, showConfirm, submissionVM, translator])

    const quotePrintDocument = useCallback(() => {
        const {getPublicID, getPath, getQuoteStatus} = PrintDocumentUtils(submissionVM);
        setIsPrinting(true);
        
        const publicID = getPublicID();
        const docPath = getPath();
        const quoteStatus = getQuoteStatus();       
        const componentProps = { submissionVM, setIsPrinting, isOpen: true, onResolve, onAfterClose, docPath, quoteStatus};       
        if (quoteStatus === 'Quoted' || quoteStatus === 'Submitted_Ext' || quoteStatus === 'Renewing') {
            CustomQuoteService.generateDocument_TWIA(publicID, 'quoteSummary', authHeader).then(() => {
                showModal(<PrintDocumentConfirmationPopup {...componentProps} />);
            });
        }  else {
            showModal(<PrintDocumentErrorPopup {...componentProps} />);
        }
    }, [authHeader, onAfterClose, onResolve, showModal, submissionVM])

    const overrideProps = {
        '@field': {
            // apply to all fields
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        questionSets: {
            path: LOB_PATH['Homeowners'],
        },
        AdditionalInterests: {
            submissionVM, updateWizardData, showErrors, findInvalidComponent, onValidate, errorDescription, setShowErrorDescription
        },
        AdditionalInsureds: {
            submissionVM, updateWizardData, showErrors, findInvalidComponent, onValidate
        },
        additionalInterestsAccordion: {
            visible: policyType !== 'HO4',
            errorState: _.includes(invalidComponent, 'AdditionalInterestDetails') && showErrors
        },
        additionalInsuredsAccordion: {
            errorState: _.includes(invalidComponent, 'AdditionalInsuredDetails') && showErrors
        },
        
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: { 
            questionset: QuestionSetComponent,
            AdditionalInterestsComponent: AdditionalInterestComponent,
            AdditionalInsuredsComponent: TFPAAdditionalInsuredComponent, // DE17111
        },
        resolveCallbackMap: {
            quotePrintDocument,
           // onValidate: onValidate,
        },
    };

    return (
      
        <WizardPage
            onNext={onNext}
            skipWhen={initialValidation}
        >
            <Loader loaded={!isLoading}>
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    model={submissionVM}
                    overrideProps={overrideProps}
                    onModelChange={updateWizardData}
                    showErrors={showErrors}
                    callbackMap={resolvers.resolveCallbackMap}
                    componentMap={resolvers.resolveComponentMap}
                    classNameMap={resolvers.resolveClassNameMap}
                />
            </Loader>
        </WizardPage>
    );
}

TFPAAdditionalInformationPage.propTypes = wizardProps;
export default TFPAAdditionalInformationPage;
